export enum Status {
    completed = 'completed',
    cancelled = 'cancelled',
    error = 'error',
    running = 'in_progress',
}

export enum Order {
    finishedAtAscending = 'finished_at',
    finishedAtDescending = '-finished_at',
    none = '',
    startedAtAscending = 'started_at',
    startedAtDescending = '-started_at',
}

export interface IExperimentsQueryFilterParams {
    search: string;
    status: string;
    ordering: string;
}
